import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Col, Row, Container } from 'react-bootstrap'

const LandingSection = ({
    title,
    texts = [],
    image,
    align = 'left'
}) => {
    return (
        <section className={classNames("landing-section", align)}>
            <Container>
                <Row className="gutters-12">
                    <Col md={6}>
                        <div className="info-container">
                            <h2 className="title">{title}</h2>
                            {texts.map((text, index) => <p className="text" key={index}>{text}</p>)}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="image-container">
                            <img src={image} alt={title} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

LandingSection.propTypes = {
    title: PropTypes.string.isRequired,
    texts: PropTypes.arrayOf(PropTypes.string),
    image: PropTypes.string.isRequired,
    align: PropTypes.oneOf(['left', 'right'])
}

export default LandingSection
